import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, Typography, CircularProgress, Box } from '@mui/material';
import apiService from '../../services/api.js';
import './RuddrProjectDetails.css';

const RuddrProjectDetails = ({ open, onClose, projectName }) => {
  const [ruddrData, setRuddrData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open || !projectName) {
      console.log('Dialog closed or no projectName:', { open, projectName });
      return;
    }

    console.log('Fetching for project:', projectName);
    const fetchRuddrProjectDetails = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await apiService.fetchData(`projects/details/${encodeURIComponent(projectName)}`);
        console.log('Raw API response:', response);
        const data = Array.isArray(response) ? response : Array.isArray(response.results) ? response.results : [];
        console.log('Parsed data:', data);
        // Sort data by member_role
        const sortedData = data.sort((a, b) => 
          a.member_role.localeCompare(b.member_role)
        );
        setRuddrData(sortedData);
      } catch (err) {
        console.error('Error fetching Ruddr project details:', err);
        setError(`Failed to load project details: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchRuddrProjectDetails();
  }, [open, projectName]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      classes={{ paper: 'Ruddr-dialog-paper' }}
      BackdropProps={{
        className: 'Ruddr-dialog-backdrop',
      }}
    >
      <DialogTitle>
        <Typography variant="h6">Ruddr Project Details - {projectName}</Typography>
        <button className="Ruddr-close-btn" onClick={onClose}>
          ×
        </button>
      </DialogTitle>
      <DialogContent className="Ruddr-dialog-content">
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error" align="center">
            {error}
          </Typography>
        ) : ruddrData.length === 0 ? (
          <Typography align="center">No data available for this project.</Typography>
        ) : (
          <div className="Ruddr-project-table-container">
            <table className="Ruddr-project-table">
              <thead>
                <tr>
                  <th>Member Name</th>
                  <th>Member Role</th>
                  <th>Project Name</th>
                </tr>
              </thead>
              <tbody>
                {ruddrData.map((row, index) => (
                  <tr
                    key={`ruddr-row-${index}`}
                    className={index % 2 === 0 ? 'Ruddr-even-row' : 'Ruddr-odd-row'}
                  >
                    <td title={row.member_name}>{row.member_name}</td>
                    <td title={row.member_role}>{row.member_role}</td>
                    <td title={row.project_name}>{row.project_name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

RuddrProjectDetails.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  projectName: PropTypes.string.isRequired,
};

export default RuddrProjectDetails;